module.exports = __webpack_public_path__ + "static/media/search.6644c0a0.svg";